import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { LeadsModel } from '../models/LeadsModel';
import { TreatmentModel } from '../models/superbit-api-models';
import { RootState } from '../app-context/store';
import { setReloadLeadTreatments } from '../app-context/leadsSlice';
import moment from 'moment';
import { set } from 'lodash';
import { setLoadTasks } from '../app-context/tasksSlice';

// create option to change handler in files belongToId like in option to change reference in EditReferenceTreatment
interface EditHandlarTreatmentProps {
    onClose: () => void;
    show: boolean;
    treatment: any;
}


const EditHandlerTreatment = (props: EditHandlarTreatmentProps) => {

    const leadsModel = new LeadsModel();
    const customerModel = new CustomerCardModel();


    const dispatch = useDispatch();

    const [treatmentsData, setTreatmentsData] = React.useState<TreatmentModel>();
    const [initialData, setInitialData] = React.useState<any>();
    const [selectedHandler, setSelectedHandler] = React.useState<any>(null);
    const [usersList, setUsersList] = React.useState<any[]>([]);

    const leadIdForTreatment = useSelector((state: RootState) => state.leads.leadIdForTreatment);


    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        const userListData = localStorage.getItem('usersList');
        if (userListData) {
            const parsedUserList = JSON.parse(userListData);
            const activeHandlerList = parsedUserList.filter((h: any) => h.status == 0
                && (h.roleId == "4a0a7e1b-7e16-4134-b8b7-de6ef7ad2aec" || h.roleId == "e026af6f-52f0-40b6-b12f-94c546da1725"
                    || h.branchId == "f65ba4e2-8fae-49da-b351-e288a9459f21" || h.branchId == "3b729183-d7a4-49a6-911e-35b63eb0c438"));

            setUsersList((prev: any) => {
                const newList = activeHandlerList.map((u: any, i: number) => {
                    return {
                        value: u.id,
                        label: u.fullName
                    }
                });
                return [...prev, ...newList];
            });
        }

        const data = await customerModel.getAssignment(props.treatment.id);
        if (data) {
            console.log('data.belongsToId', data.belongsToId);
            const userListData = localStorage.getItem('usersList');
            if (userListData) {
                const parsedUserList = JSON.parse(userListData);
                console.log('parsedUserList', parsedUserList);
                const handler = parsedUserList.find((user: any) => user.id == data.belongsToId);
                console.log('handler', handler);
                if (handler) {
                    setSelectedHandler(handler.fullName);
                }
                setTreatmentsData(data);
                setInitialData({...data});
            }
        }
    }

    const onSelectBelongsTo = (e: any) => {
        const selectedValue = e.target.value;
        console.log('selectedValue', selectedValue);
        const selectedUser = usersList.find((user) => user.label === selectedValue);
        setSelectedHandler(selectedValue);
        if (selectedUser) {
            const treatment = treatmentsData as TreatmentModel;
            treatment.belongsToId = selectedUser.value;
            setTreatmentsData(treatment);
        }
    }

    const onSelectedHandlerClear = () => {
        setSelectedHandler('');
        const treatment = treatmentsData as TreatmentModel;
        treatment.belongsToId = undefined;
        setTreatmentsData(treatment);
    }

    const saveTreatment = async () => {
        const data = treatmentsData as TreatmentModel;
        const initial = initialData;
        console.log('data', data)
        console.log('initial', initial)

        const savedLoggedUser = localStorage.getItem('loggedUser');
        let loggedUser: any = {}
        if (savedLoggedUser) {
            loggedUser = JSON.parse(savedLoggedUser);
        }


        let editHistory = '';

        editHistory += `מטפל שונה`;
        const prevCompanyName = usersList.find((s: any) => s.value == initial.belongsToId)
        const newCompanyName = usersList.find((s: any) => s.value == data.belongsToId)
        if (initial.belongsToId === data.belongsToId) {
            console.log('same belongsToId')
            console.log('belongsToId', initial.belongsToId, data.belongsToId)
        } else {
            if (prevCompanyName) {
                editHistory += ` מ-"${prevCompanyName.label}"`;
            }
            if (newCompanyName) {
                editHistory += ` ל-"${newCompanyName.label}"`;
            }
            console.log('editHistory', editHistory)

            if (!data.id && data.treatmentActivities) {
                data.treatmentActivities.push({
                    createdDate: moment().format('YYYY-MM-DDTHH:mm'),
                    topic: 'תיעוד הוקם ',
                    note: editHistory.replace(/&nbsp;/g, ' '),
                    createdById: loggedUser.id
                })
                console.log('data.treatmentActivities', data.treatmentActivities)

            } else {
                if (!data.treatmentActivities) {
                    data.treatmentActivities = [];
                }

                data.treatmentActivities.push({
                    createdDate: moment().format('YYYY-MM-DDTHH:mm'),
                    topic: 'עדכון תיעוד',
                    note: editHistory.replace(/&nbsp;/g, ' '),
                    createdById: loggedUser.id
                })
                console.log('data.treatmentActivities', data.treatmentActivities)


            }
        }
        setTreatmentsData(data);
        const newData = treatmentsData as TreatmentModel;
        if (newData) {
            const res = await customerModel.treatmentsUpsertTreatment(newData);
            if (res && res.label === "טיפול שוטף נוצר בהצלחה!" || res.label === "טיפול שוטף עודכן בהצלחה!") {

                props.onClose();
                if (leadIdForTreatment && leadIdForTreatment.length > 0) {
                    dispatch(setReloadLeadTreatments(true));
                } else {
                    dispatch(setLoadTasks(true));
                }
            }
        }
    }



    return (
        <div className={`popup-wrapper small-warning`} style={{ position: 'fixed' }}>
            <section className="popup-window rtl" style={{ height: 236 }}>
                <div className="close-icon pointer" onClick={(e: any) => props.onClose()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {/* {props.messageTitle} */}
                        </div>
                    </div>
                    <div className="popup-body">
                        <div className="parameter-row" style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: '20px'
                        }}>
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        לטיפול ע"י:
                                    </div>
                                    <div className="value">
                                        <input type='text'
                                            list="handler_list"
                                            placeholder='בחר מטפל'
                                            onChange={(e: any) => onSelectBelongsTo(e)}
                                            value={selectedHandler}
                                        />
                                        <datalist id="handler_list">
                                            {usersList && usersList.map((u: any, i: number) => <option key={i} value={u.label}>{u.label}</option>)}
                                        </datalist>
                                        <div className={`icon x-clear pointer ${selectedHandler == '' ? 'hide' : ''}`} onClick={onSelectedHandlerClear}></div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="popup-footer">
                        <button className="button blue pointer" onClick={saveTreatment}>
                            שמור
                        </button>

                        <button className="button white blue-border pointer" onClick={(e: any) => props.onClose()}>
                            ביטול
                        </button>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default EditHandlerTreatment